import { useEffect } from 'react';
import { I18nProvider, useI18n } from './i18n';
import { Link, RouterProvider, useRouter } from './router';
import { Footer, Header } from './components/SiteChrome';
import { HomePage } from './pages/HomePage';
import { ProductConfiguratorPage } from './pages/ProductConfiguratorPage';
import { GiftConfiguratorPage } from './pages/GiftConfiguratorPage';
import { kindForPath } from './configurator/registry';

function Routes() {
  const { path } = useRouter();
  const { d } = useI18n();
  useEffect(() => {
    document.body.dataset.route = path === '/' ? 'home' : 'app';
  }, [path]);

  if (path === '/' || path === '') return <HomePage />;
  if (path === '/configurator') return <ProductConfiguratorPage product="candle" />;
  const kind = kindForPath(path);
  if (kind === 'gift') return <GiftConfiguratorPage />;
  if (kind) return <ProductConfiguratorPage product={kind} />;
  return (
    <main className="wrap notfound" id="main">
      <p className="mono muted">404</p>
      <h1 className="section__title">{d.notFound.title}</h1>
      <Link to="/" className="btn btn--primary">
        {d.notFound.back}
      </Link>
    </main>
  );
}

export function App() {
  return (
    <I18nProvider>
      <RouterProvider>
        <a className="skip" href="#main">
          ↓
        </a>
        <Header />
        <Routes />
        <Footer />
      </RouterProvider>
    </I18nProvider>
  );
}
